import styled from "styled-components"

export const StyledDatePicker = styled.div`
  display: flex;
  width: 100%;
  padding: var(--spacing_m, 12px) 0px;
  flex-direction: column;
`

export const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 5px;
  padding: 0 16px 6px 24px;
  height: 46px;
`

export const CurrentMonth = styled.div`
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 140%;
`

export const NavigateBox = styled.div`
  display: flex;
  gap: 8px;
`

export const NavigationButtonWrapper = styled.div`
  padding: 8px;
`

export const NavigateButton = styled.button`
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: none;
  width: 24px;
  height: 24px;
  padding: 0px;

  &:hover {
    background: rgba(0, 38, 58, 0.14);
  }
`

export const TodayButton = styled.button`
  display: flex;
  height: var(--spacing_xl, 24px);

  padding: 0px var(--spacing_m, 12px);
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: var(--spacing_xxs, 4px);
  border: 0.5px solid var(--Schemes-Outline-Variant, rgba(0, 38, 58, 0.14));

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  color: var(--Schemes-On-Surface-Variant, #69757d);

  background: transparent;
  line-height: normal;

  &:hover {
    background: rgba(0, 38, 58, 0.14);
  }
`

const getDateBackground = (props: {
  $isSelected: boolean
  $isToday: boolean
  $available: boolean
}) => {
  if (props.$isSelected) {
    return "var(--Schemes-Primary, #0DA3BA)"
  }
  if (props.$isToday) {
    return "var(--Schemes-Surface-Container, #EBEDF0)"
  }
  return "transparent"
}

const getHoveredDateBackground = (props: {
  $isSelected: boolean
  $available: boolean
  $isDisabled: boolean
}) => {
  if (props.$isDisabled) {
    return "transparent"
  }

  if (props.$isSelected) {
    return "var(--Schemes-Primary, #0DA3BA)"
  }

  return "var(--Schemes-Surface-Container, #EBEDF0)"
}

export const DateButton = styled.button<{
  $available: boolean
  $isSelected: boolean
  $isToday: boolean
  $isDisabled: boolean
}>`
  position: relative;
  font-size: 14px;
  line-height: 14px;
  width: 36px;
  height: 36px;
  color: var(--ratio);
  pointer-events: auto;
  opacity: 1;
  cursor: ${(props) => (props.$isDisabled ? "not-allowed" : "pointer")};
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: ${(props) => getHoveredDateBackground(props)};

    .date_btn__dot {
      background: ${(props) =>
        props.$isSelected && props.$available
          ? "#fff"
          : "var(--Schemes-Primary, #0DA3BA)"};
    }
  }

  border-radius: 50%;
  background: ${(props) => getDateBackground(props)};

  opacity: ${(props) => (props.$isDisabled ? "0.3" : "1")};
`

const getDayTextColor = (props: {
  $isSelected: boolean
  $available: boolean
  $isToday: boolean
}) => {
  if (props.$isSelected) {
    return "#fff"
  }

  if (props.$isToday) {
    return "var(--Schemes-Primary, #0DA3BA)"
  }

  if (props.$available) {
    return "#000"
  }

  return "var(--Schemes-On-Surface, #1C1F21)"
}

export const DateButtonText = styled.div<{
  $available: boolean
  $isSelected: boolean
  $isToday: boolean
}>`
  position: relative;
  z-index: 11;
  font-weight: ${(props) => (props.$isSelected ? 700 : 400)};
  color: ${(props) => getDayTextColor(props)};
  opacity: ${(props) => (props.$available ? "1" : "0.16")};
`

export const TodayButtonDot = styled.div<{
  $isSelected: boolean
  $isInDifferentMonth: boolean
}>`
  position: absolute;
  z-index: 12;
  bottom: 4px;
  left: 50%;
  transform: translateX(-50%);
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: ${(props) =>
    props.$isSelected
      ? "#fff"
      : props.$isInDifferentMonth
      ? "var(--Schemes-Outline-Variant, rgba(0, 38, 58, 0.14))"
      : "var(--Schemes-Primary, #0DA3BA)"};
`

export const StyledThR = styled.tr`
  display: flex;
  justify-content: space-between;
  width: 100%;

  &:not(:first-child) {
    margin-top: 4px;
  }
`

export const StyledTh = styled.th`
  display: flex;
  min-width: 44px;
  width: calc(100% / 7);
  height: 18px;
  flex-direction: column;
  justify-content: center;

  color: var(--Schemes-On-Surface-Variant, #69757d);
  text-align: center;

  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
`

export const StyledTr = styled.tr`
  display: flex;
  align-self: stretch;
  position: relative;
  margin-top: 4px;
  margin-bottom: 4px;
`

export const StyledTd = styled.td`
  display: flex;
  height: 36px;
  width: 36px;
  padding: 0px;
  justify-content: center;
  align-items: center;
  flex: 1 0 0;
`

export const MonthGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  width: 100%;
  margin: 0 auto;
  grid-row-gap: 8px;
  padding: 0px var(--app-horizontal-padding);
`

export const MonthButton = styled.div<{
  $isDisabled: boolean
}>`
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;

  cursor: ${(props) => (props.$isDisabled ? "not-allowed" : "pointer")};
  background: ${(props) => (props.$isDisabled ? "#EBEDF0" : "transparent")};
`

export const MonthButtonText = styled.div<{
  $isSelected: boolean
  $isDisabled: boolean
  $isNotIn10YearsRange?: boolean
}>`
  font-weight: 600;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 34px;
  background: ${(props) =>
    props.$isSelected ? "#CCEDED" : props.$isDisabled ? "#EBEDF0" : "#fff"};

  opacity: ${(props) =>
    props.$isDisabled ? "0.16" : props.$isNotIn10YearsRange ? "0.16" : "1"};
  cursor: ${(props) => (props.$isDisabled ? "not-allowed" : "pointer")};

  &:hover {
    background: ${(props) => (props.$isDisabled ? "#EBEDF0" : "#CCEDED")};
  }
`

export const ChangeSectionButton = styled.span`
  cursor: pointer;
  &:hover {
    color: var(--Schemes-Primary, #0da3ba);
  }
`

export const TableWrapper = styled.div`
  padding: 0px var(--spacing_m, 12px);
`
